export default __webpack_public_path__ + "static/epica-lite-6-d05f2d6bf639f38a79feb65b793688cd.jpg";